<!------------------------------------------------------------->
<ng-template #searchSuggestionstemp>
  <div class="search-suggestions">
    <div class="container d-flex flex-column align-items-start p-3 shadow rounded" style="background-color: var(--white);"
      (clickOutside)="searchSuggestions = []" *ngIf="searchSuggestions?.length">
      <ng-container *ngFor="let entry of searchSuggestions">
        @if(entry.type == 'company'){
          <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" (click)="openSuggestionText(entry.name)" >
            {{ entry.name }} ( <b>Company</b> )
          </button>

        }@else{
          <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" (click)="openSuggestionText(entry.name)" >
            {{ entry.name }} ( <b>{{ entry.type == "type" ? ("Sub Category:" + entry.parentCategoryName  )  : entry.type == "cat" ? "Category" : "Subcategory"
              }}</b> )
          </button>
          
          <ng-container *ngIf="entry?.types">
            <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" *ngFor="let subTypes of entry?.types"
              (click)="openSuggestionText(subTypes.name)">{{ subTypes.name }} (<b>Type</b>)</button>
          </ng-container>
          <ng-container *ngIf="entry?.subcats">
            <ng-container *ngFor="let subEntry of entry?.subcats">
              <button class="t-btn w-100" style="text-align: left; line-height: 1.3;"
                (click)="openSuggestionText(subEntry.name)">{{ subEntry.name }} (<b>Subcategory</b>)</button>
              <ng-container *ngIf="subEntry?.types">
                <button class="t-btn w-100" style="text-align: left; line-height: 1.3;" *ngFor="let subTypes of subEntry?.types"
                  (click)="openSuggestionText(subTypes.name)">{{ subTypes.name }} (<b>Type</b>)</button>
              </ng-container>
            </ng-container>
          </ng-container>

        }
     
      </ng-container>
    </div>
  </div>
</ng-template>
<!------------------------------------------------------------->

<div class="search-mobile">
  <div class="position-absolute w-100" style="top: calc(100%)">
    <div *ngTemplateOutlet="searchSuggestionstemp"></div>
  </div>
  <div class="my-input">
    <i class="fa-solid fa-search"></i>
    <input type="text" [(ngModel)]="maps.search" placeholder="Look for Services" (focus)="getSearchSuggestions($event)" (keydown)="getSearchSuggestions($event)" (keydown.enter)="openFilterModal(filterPopup)" />
  </div>
</div>
<div class="search-header">
  <div class="container">
    <div *ngTemplateOutlet="searchSuggestionstemp; context: { data: searchSuggestions }"></div>
    <div class="bar" [class.active]="arrow">
      <div class="my-input search" style="position: relative">
        <div class="my-input__title">{{ "" }}</div>
        <input type="text" [(ngModel)]="maps.search" placeholder="Look for Services" (focus)="getSearchSuggestions($event)" (keydown)="getSearchSuggestions($event)" (keydown.enter)="openFilterModal(filterPopup)" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Postal</div>
        <input type="text" [(ngModel)]="maps.postalCode" placeholder="Postal Code" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Radius</div>
        <select [(ngModel)]="maps.radius">
          <option value="0" selected disabled>Radius</option>
          <option *ngFor="let radius of [0.2, 1, 2, 5, 'All']" [value]="radius">
            {{ radius == "All" ? "All" : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
        </select>
      </div>
      <div class="icon-search" (click)="openFilterModal(filterPopup)">
        <i class="fa-solid fa-search"></i>
      </div>
      <div class="keyword" *ngIf="popularKeywords.length > 0">
        <p class="keyword__title">Popular Search</p>
        <p class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</p>
        <div #keywordContainer class="buttons">
          <button class="keyword__btn" *ngFor="let row of popularKeywords"
            (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
        </div>
      </div>
      <!-- <i class="fa-solid fa-angle-down arrow" (click)="arrow = !arrow"></i> -->
    </div>
    <ng-content></ng-content>
  </div>
</div>
<!-- <button (click)="openPopupModal(popup)">
  open popup
</button> -->
<!-- <div class="header">
  <div class="overlay">
    <div class="bar" [class.active]="arrow">
      <div class="my-input search" style="position: relative">
        <div class="my-input__title">{{ "" }}</div>
        <input type="text" [(ngModel)]="maps.search" placeholder="Search" (keydown.enter)="openFilterModal(filterPopup)" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Postal</div>
        <input type="text" [(ngModel)]="maps.postalCode" placeholder="Postal Code" />
      </div>
      <div class="my-input">
        <div class="my-input__title">Radius</div>
        <select [(ngModel)]="maps.radius">
          <option value="0" selected disabled>Radius</option>
          <option *ngFor="let radius of [0.2, 1, 2, 5, 'All']" [value]="radius">
            {{ radius == "All" ? "All" : radius < 1 ? radius * 1000 + "m" : radius + "km" }}
          </option>
        </select>
      </div>
      <div class="icon-search" (click)="openFilterModal(filterPopup)">
        <i class="fa-solid fa-search"></i>
      </div>
      <div class="keyword" *ngIf="popularKeywords.length > 0">
        <p class="keyword__title">Popular Search</p>
        <p class="d-none" *ngFor="let row of popularKeywords">{{ row.text }}</p>
        <div #keywordContainer class="buttons">
          <button class="keyword__btn" *ngFor="let row of popularKeywords" (click)="maps.search = row.text; openFilterModal(filterPopup)">{{ row.text }}</button>
        </div>
      </div>
    </div>
  </div>
</div> -->

<ng-template #filterPopup let-modal>
  <div class="modal-map">
    <div class="modal-map__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-6">
          <app-google-map [params]="maps" (view)="viewProduct($event)" [isSearchFromHomepage]="isSearchFromHomepage"
            (paramChange)="paramChange()"></app-google-map>
        </div>
        <div class="col-lg-6">
          <div class="modal-map__nav">
            <div>
              <button (click)="handleSearch(row)" *ngFor="let row of [0.2, 1, 2, 5, 'All']">
                {{ row == "All" ? "All" : row < 1 ? row * 1000 + "m" : row + "km" }} </button>
            </div>
          </div>
          <div *ngIf="!maps.all && !maps.home && !maps.business">
            <div class="alert alert-warning text-center mb-2" role="alert"><i class="fa-solid fa-checkmark"></i> Please
              Check Home or Business</div>
          </div>
          <div class="top-btns">
            <ng-container *ngFor="let keywordSubCat of maps.subCategoriesBasedOnKeyWords">
              <ng-container  *ngFor="let type of keywordSubCat.subcategoryTypes?.slice(0, showMoreKeywords ?  keywordSubCat.subcategoryTypes?.length: 8)">
                <button class="card-sub-cate mr-2 mt-2" [class.active]="selectedTypesId.has(type)"
                  (click)="toggleTypeAndSearch(type)">
                  <span class="card-sub-cate__title ">
                    {{ type.name }}
                  </span> 
                </button>
              </ng-container>
             
            </ng-container>
           
          </div>
          <div class="d-flex w-100 justify-content-center mt-2" *ngIf=" maps.subCategoriesBasedOnKeyWords?.length == 1 &&
                maps.subCategoriesBasedOnKeyWords[0].subcategoryTypes?.length > 8
          ">
            <button class="t-btn" (click)="showMoreKeywords = !showMoreKeywords"> Show {{showMoreKeywords ? "Less" : "More"}}  </button>
            </div>
         

          <div class="top-btns">
            <ng-container *ngFor="let subCat of maps.subcats.slice(0, showMoreSubcats ?  maps.subcats?.length: 8)  ">

              <button class="card-sub-cate mr-2 mt-2" [class.active]="selectedSubCatIds.has(subCat.id)"
                (click)="toggleSubCatAndSearch(subCat)">
                <span class="card-sub-cate__title ">
                  {{ subCat.name }}
                </span>
                
              </button>

            </ng-container>
          </div>
          <div class="d-flex w-100 justify-content-center mt-2" *ngIf="maps.subcats?.length > 8">
            <button class="t-btn" (click)="showMoreSubcats = !showMoreSubcats"> Show {{showMoreSubcats ? "Less" : "More"}}  </button>
          </div>

          <div class="dropdown my-2 mr-2 d-flex justify-content-end filter-map">
            <button class="btn btn-sm btn-light dropdown-toggle" type="button" id="filterDropdown"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa-solid fa-filter"></i>
              Filter <span class="badge badge-primary" *ngIf="selectedFilterMap.length > 0">{{ selectedFilterMap.length
                }}</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="filterDropdown">
              <button class="dropdown-item" *ngFor="let filter of filterMaps" (click)="handleFilterMap(filter)"
                [class.active]="selectedFilterMap.includes(filter)">
                <i class="{{ filter.icon }} mr-2"></i> {{ filter.name }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div *ngIf="maps.products?.length < 1">
            <div class="alert alert-secondary text-center" role="alert"><i class="fa-solid fa-shopping-cart"></i> No
              Products Available</div>
          </div>
          <div *ngIf="maps.products?.length > 0" class="modal-map__body">
            <div class="products">
              <common-product-card-view (selected)="productSelectedChanged(row, $event)" [isSelected]="i < 5"
                (view)="viewProduct($event)" *ngFor="let row of maps.products; index as i" [list]="row"
                [isCommunityProduct]="true" [isSearch]="true"
                [filterMapsIcon]="selectedFilterMap"></common-product-card-view>
              <!-- <app-product-faq-list [additionalFAQS]="maps.fetchedFaqs"></app-product-faq-list> -->
              <div class="card  selectcat-faqs d-flex flex-column w-100 p-4 p-2" style="gap: .5em;" *ngIf="faqsExist">
                <span style="font-size: 1.2rem; font-weight: bold;">FAQ</span>
                <div *ngIf="maps.fetchedFaqs.questionOne && maps.fetchedFaqs.answerOne" (click)="showFAQ(0)">
                  <div class="arrow-border">
                    {{ maps.fetchedFaqs.questionOne }}
                  </div>
                  <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerOne" *ngIf="visibleFAQ[0]"></div>
                </div>

                <div *ngIf="maps.fetchedFaqs.questionTwo && maps.fetchedFaqs.answerTwo" (click)="showFAQ(1)">
                  <div class="arrow-border">
                    {{ maps.fetchedFaqs.questionTwo }}
                  </div>
                  <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerTwo" *ngIf="visibleFAQ[1]"></div>
                </div>

                <div *ngIf="maps.fetchedFaqs.questionThree && maps.fetchedFaqs.answerThree" (click)="showFAQ(2)">
                  <div class="arrow-border">
                    {{ maps.fetchedFaqs.questionThree }}
                  </div>
                  <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerThree" *ngIf="visibleFAQ[2]"></div>
                </div>

                <div *ngIf="maps.fetchedFaqs.questionFour && maps.fetchedFaqs.answerFour" (click)="showFAQ(3)">
                  <div class="arrow-border">
                    {{ maps.fetchedFaqs.questionFour }}
                  </div>
                  <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerFour" *ngIf="visibleFAQ[3]"></div>
                </div>

                <div *ngIf="maps.fetchedFaqs.questionFive && maps.fetchedFaqs.answerFive" (click)="showFAQ(4)">
                  <div class="arrow-border">
                    {{ maps.fetchedFaqs.questionFive }}
                  </div>
                  <div class="answer-block" [innerHTML]="maps.fetchedFaqs.answerFive" *ngIf="visibleFAQ[4]"></div>
                </div>


              </div>
              <button class="addrecomm-btn" (click)="openRecommendationForm()">+ <small>Recommend</small></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-marketplace #marketplace [share]="true"></app-marketplace>
  </div>
</ng-template>

<ng-template #popup let-modal>
  <div>
    <div class="modal-popup__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <div class="modal-popup__modal-body">
      <app-my-carousel-swiper [navigation]="false" [config]="carouselOptions" (onSlideChange)="popupSlider($event)">
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-1.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-2.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-3.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-4.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-5.jpg" />
        </div>
        <div class="swiper-slide">
          <img style="height: 300px; width: 100%; object-fit: cover"
            src="https://swiperjs.com/demos/images/nature-6.jpg" />
        </div>
      </app-my-carousel-swiper>
      <div class="my-popup">
        <div class="my-popup__title">{{ titles[currentIndex] }}</div>
        <div class="my-popup__desc">{{ descriptions[currentIndex] }}</div>
        <div class="my-popup__buttons">
          <button class="my-button-3">Explore</button>
          <button class="my-button-3 secondary">Login</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
